require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./chiffres-et-statistiques-2-0-4.json") })
        }
      }, "path---chiffres-et-statistiques-2-0-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---chiffres-et-statistiques-2-0-4!./.cache/json/chiffres-et-statistiques-2-0-4.json
// module id = 368
// module chunks = 231608221292675